module.exports = __webpack_public_path__ + "img/memory_mob.ee86da73.svg";